// extracted by mini-css-extract-plugin
export default {"Body":"courses_Body__Jdwm4","Content":"courses_Content__29fRA","Courses":"courses_Courses__Ix6Ju","Course":"courses_Course__1nXot","CoursesHeader":"courses_CoursesHeader__HkVvc"};